import React from 'react';
import dayjs from 'dayjs';
import { StatusTag } from '../../../common';

/** Activo / Expirado / Inactivo pill for contracts and campaigns. */
export default function TradeStatusTag({ record }) {
    if (!record.active) return <StatusTag tone="neutral" dot>Inactivo</StatusTag>;
    const isExpired = record.expirationDate && dayjs(record.expirationDate).isBefore(dayjs());
    return isExpired ? (
        <StatusTag tone="danger" dot>
            Expirado
        </StatusTag>
    ) : (
        <StatusTag tone="success" dot>
            Activo
        </StatusTag>
    );
}
